import { PropertyPayment, RVPropertyType } from "./entities";

export interface Owner {
	OwnerId: number;
	OwnerNumber: number;
	OwnerNameEn: string;
	OwnerNameAr: string;
	OwnerMobile?: any;
	OwnerEmiratesId?: any;
	OwnerPartId: number;
	OwnerPassportNumber?: any;
	OwnerCountryId: number;
	Identity: number;
}

export interface AssociatedContract {
	Identity: number;
	PropertiesDataId?: any;
	ContractId: number;
	ContractTypeId: number;
	ContractNumber: string;
	ContractStartDate: string;
	ContractEndDate: string;
	GraceStartDate?: any;
	GraceEndDate?: any;
	ContractAmount: number;
	ContractRank: number;
	ContractTenantNameEn: string;
	ContractTenantNameAr: string;
	ManagementCompanyId?: any;
	TotalCount?: any;
	ContractStatusId?: any;
	ContractStatusNameEn?: any;
	ContractStatusNameAr?: any;
	ContractTenantMobile?: any;
	ContractTenantUNumber?: any;
	ContractTenantEmiratesId?: any;
	ContractTenantId: number;
	IsSublease?: any;
	Properties: any[];
	PassportNo?: any;
	PassportIssueDate?: any;
	PassportExpiryDate?: any;
	TenantParticipantId?: any;
	LicenseStateId?: any;
	LicenseTypeId?: any;
	LicenseNumber?: any;
	InitialApprovalNumber?: any;
	LicenseIssueDate?: any;
	LicenseExpiryDate?: any;
}

export interface Property {
	LandNo: string;
	LandSubNo: string;
	UsageNameAr: string;
	UsageNameEn: string;
	LandDmNo: string;
	LandDmSubNo: string;
	MakaniNumber?: any;
	Size: string;
	Dewa: string;
	Rank: string;
	UnitEjariPropertyId: string;
	VillaEjariPropertyId: string;
	BuildingEjariPropertyId: string;
	LandEjariPropertyId: string;
	ContractStartDate: string;
	TenantNameAr: string;
	TenantNameEn: string;
	ManagementCompanyId: string;
	Owners: Owner[];
	IsFreeHold: boolean;
	PropertyTypeId: RVPropertyType;
	LandPropertyId: number;
	BuildingPropertyId: number;
	VillaPropertyId?: any;
	UnitPropertyId: number;
	Units?: any;
	IsRented: boolean;
	AssociatedContracts: AssociatedContract[];
	AssociatedManagementContract?: any;
	AssociatedDewaAccounts?: any;
	EjariPropertyUsageId: number;
	EjariTypeId: number;
	EjariSubTypeId: number;
	EjariUsageId?: any;
	LandTypeId: number;
	PropertyNumber: string;
	PropertyId: number;
	EstimatedValue?: any;
	GeneralFund?: any;
	ReserveFund?: any;
	ChargePrSqft?: any;
	ChargePrSqm?: any;
	TotalCharges?: any;
	ApplicableArea?: any;
	RentalIndexMin?: any;
	RentalIndexMax?: any;
	TabuPropertyId?: any;
	TabuPropertyTypeId?: any;
	TabuPropertySubTypeId?: any;
	UnitNo: string;
	BuildingNameEn: string;
	BuildingNameAr: string;
	AreaEn: string;
	AreaAr: string;
	LandTypeNameEn?: any;
	LandTypeNameAr?: any;
	EjariUsageNameEn?: any;
	EjariUsageNameAr?: any;
	EjariTypeNameEn: string;
	EjariTypeNameAr: string;
	EjariSubTypeNameEn: string;
	EjariSubTypeNameAr: string;
	Rooms?: any;
	Latitude: string;
	Longitude: string;
	MoreData: string;
	IndexRoomType: string;
	IndexAreaId: string;
	IndexSubAreaId: string;
	ContractEndDate: string;
	ContractAmount: string;
	ContractNumber?: any;
	ContractTypeId?: any;
	ContractId?: any;
	LandAreaId: number;
	Identity: number;
	rvData?: RVData;
	PropertyCompletionDate?: string;
}

export interface RVDocumentPage {
	localUri?: string;
	remoteUri?: string;
	remoteId?: number;
	lookupId?: number;
	file?: File;
}

export interface RVDocument {
	lookupId: number;
	pages: RVDocumentPage[];
}

export interface RVData {
	isDataCompleted?: boolean;
	oData?: Partial<RVProperty>;
	data?: Partial<RVProperty>;
	documents?: RVDocument[];
}

export interface RVProperty {
	AreaId: number;
	AreaNameAr: string;
	AreaNameEn: string;
	BuildingEjPropertyId?: number;
	BuildingNameAr?: string;
	BuildingNameEn?: string;
	BuildingPropertyId?: number;
	CertificateNumber?: string;
	CertificateYear?: number;
	ContractAnnualAmount?: number;
	ContractEndDate?: string;
	ContractNumber?: string;
	ContractStartDate?: string;
	DewaNumber?: string;
	EjariSubTypeId?: number;
	EjariSubTypeNameAr?: string;
	EjariSubTypeNameEn?: string;
	EjariTypeId: number;
	EjariTypeNameAr?: string;
	EjariTypeNameEn?: string;
	EjariUsageId?: number;
	EjariUsageNameAr?: string;
	EjariUsageNameEn?: string;
	Identity: number;
	IsCompletedProperty: 0 | 1;
	IsFreehold: 0 | 1;
	IsRented: 0 | 1;
	LandDmNo?: string;
	LandDmSubNo?: string;
	LandEjPropertyId: number;
	LandNo: string;
	LandPropertyId: number;
	LandSubNo: string;
	PreviousEvaluationsResults?: any;
	PropertyCompletionDate: string;
	PropertyDescription: string;
	PropertyId: number;
	PropertyNumber: string;
	PropertySize: number;
	PropertyTypeId: number;
	PropertyTypeNameAr?: string;
	PropertyTypeNameEn?: string;
	RequestId?: number;
	UnitEjPropertyId: number;
	UnitPropertyId?: number;
	VillaEjPropertyId?: number;
	VillaPropertyId?: number;
	PropertyPaymentStructure?: PropertyPayment;
}

export function RvPropertyToProperty( rvProp: RVProperty ): Property {
	return {
		...rvProp,
		PropertyTypeId: rvProp.PropertyTypeId,
		UnitNo: rvProp.PropertyNumber,
		AreaEn: rvProp.AreaNameEn,
		AreaAr: rvProp.AreaNameAr,
		Size: rvProp.PropertySize,

	} as any as Property;
}
